// Backfills detail-page-only product fields (wine_making, reviews,
// technical_notes, tasting_notes, prev_tasting_notes, related_products)
// that the SSR-inlined initial state deliberately omits - see
// SSR_DEFERRED_PRODUCT_FIELDS in
// dev/vuejs-drupal-store/utils/applyFieldMapper.js. Client-side (non-SSR)
// product loads always include these already, so this is a no-op there;
// it only does real work right after SSR hydration, the first time a
// detail view for a given product mounts.
//
// Consuming components must expose the product being displayed as
// `this.item` or `this.product` (override the lazyLoadProduct computed if
// neither fits), and should gate any markup that reads the deferred fields
// behind `productDetailIsComplete` (with a loading state while it's false).
export default {
  data() {
    return {
      productDetailLoading: false
    }
  },
  computed: {
    lazyLoadProduct() {
      return this.item || this.product || null
    },
    productDetailIsComplete() {
      const p = this.lazyLoadProduct
      return !p || Object.prototype.hasOwnProperty.call(p, 'wine_making')
    }
  },
  watch: {
    lazyLoadProduct: {
      immediate: true,
      handler() {
        this.ensureProductDetailLoaded()
      }
    }
  },
  methods: {
    ensureProductDetailLoaded() {
      const p = this.lazyLoadProduct
      if (!p || !p.id || this.productDetailIsComplete || this.productDetailLoading) return

      this.productDetailLoading = true
      this.$store.dispatch('products/loadProductByQuery', {
        id: p.id,
        map: this.$store.getters['products/findMapSetting'](p.type || '')
      })
        .finally(() => {
          this.productDetailLoading = false
        })
    }
  }
}
